import Typography from '@mui/material/Typography'
import moment from 'moment-timezone'

export const DateInfoItem = ({ date }) => {
    const ts = Intl.DateTimeFormat().resolvedOptions().timeZone
    return (
        <Typography
            variant="caption2"
            component="p"
            sx={{ color: '#5A5F72', marginBottom: '12px' }}>
            {moment(date).tz(ts).format('D MMM YYYY')} • {moment(date).tz(ts).format('HH:mm')}
        </Typography>
    )
}
